import Modal from './Modals'
import Control from './Control'

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    RUN_LOADING (state) {
      state.loading = true
    },
    STOP_LOADING (state) {
      state.loading = false
    }
  },
  actions: {
  },
  modules: {
    Modal,
    Control
  }
}
